import { createAction, props } from '@ngrx/store';
import { Attribute } from '@emm/core/models/attribute.model';
import {AttributeType} from '@emm/core/models/attribute-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';


export enum AttributesAction {
    LoadGlobalAttributes = '[Attributes FX] Load Global Attributes',
    LoadGlobalAttributesSuccess = '[Management API] Load Global Attributes Success',
    LoadGlobalAttributesFailure = '[Management API] Load Global Attributes Failure',
    Load = '[Attributes Management] Load Attributes',
    LoadSuccess = '[Management API] Load Attributes Success',
    LoadFailure = '[Management API] Load Attributes Failure',
    Select = '[Attributes Management] Select Attribute',
    SearchAttributes = '[Attributes Management] Search Attributes',
    OpenAddDialog = '[Attributes Management] Open Add Attribute Dialog',
}

export const AttributesActions = {
    loadGlobalAttributes: createAction(AttributesAction.LoadGlobalAttributes),
    loadGlobalAttributesSuccess: createAction(
        AttributesAction.LoadGlobalAttributesSuccess,
        props<{ attributes: Attribute[] }>()
    ),
    loadGlobalAttributesFailure: createAction(
        AttributesAction.LoadGlobalAttributesFailure,
        props<{ error: any }>()
    ),
    load: createAction(AttributesAction.Load),
    loadSuccess: createAction(
        AttributesAction.LoadSuccess,
        props<{ attributes: Attribute[]; attributeTypes: AttributeType[] }>()
    ),
    loadFailure: createAction(AttributesAction.LoadFailure, props<{ error: any }>()),
    select: createAction(AttributesAction.Select, props<{ tag: string }>()),
    searchAttributes: createAction(AttributesAction.SearchAttributes, props<{ filter: SearchFilter }>()),
    openAddDialog: createAction(AttributesAction.OpenAddDialog)
};

export const AsyncActions = {
    loadActions: [AttributesActions.loadGlobalAttributes, AttributesActions.load],
    successActions: [AttributesActions.loadGlobalAttributesSuccess, AttributesActions.loadSuccess],
    errorActions: [AttributesActions.loadGlobalAttributesFailure, AttributesActions.loadFailure]
};
